import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ContactData } from 'src/lib/fliko/models/estate/contact.data';
import { Nullish } from 'src/lib/fliko/types/typeish.type';
import { DatabaseService } from 'src/app/shared/services/database.service';

@Injectable({ providedIn: 'root' })
export class ContactsService {
  constructor(private dbSrv: DatabaseService) {}

  /**
   * @path /contact/$estateId/
   * @key id
   */
  private get contact() {
    return this.dbSrv.estateFactory.getCollection<ContactData>('contact/$eId');
  }

  public getContacts$(): Observable<ContactData[]> {
    return this.contact.getList();
  }

  public getContact$(id: string): Observable<ContactData | Nullish> {
    return this.contact.getElement(id);
  }

  public setContact(contact: ContactData): Promise<void> {
    return this.contact.setElement(contact.id, contact);
  }

  public updateContact(contact: ContactData): Promise<void> {
    return this.contact.updateElement(contact.id, contact);
  }

  public removeContact(id: string): Promise<void> {
    return this.contact.removeElement(id);
  }
}
